<template>
  <div class="mt-3" v-if="tier.tierDetails.length">
    <h5>{{ tierHeader }}</h5>
    <div class="tier-gallery">
      <div
        class="gallery-image"
        v-for="product in computedList"
        :key="product.itemId"
      >
        <ProductPortrait
          v-if="product.itemableType === 'Product'"
          :tier="tier"
          :product="product"
          :selectedVariants="selectedVariants"
          :payload="payload"
          :giftsLimit="giftsLimit"
          @handleSelection="handleSelection"
          @updateProductVariant="data => $emit('updateProductVariant', data)"
        />
        <BundlePortrait
          v-else
          :tier="tier"
          :product="product"
          :selectedVariants="selectedVariants"
          :activeItems="activeItems"
          :payload="payload"
          :giftsLimit="giftsLimit"
          :oldData="getBundleSelected(product.itemableId)"
          @handleSelection="handleSelection"
          @updateProductVariant="data => $emit('updateProductVariant', data)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProductPortrait from './ProductPortrait'
import BundlePortrait from './BundlePortrait'
import { isCard } from '../../helpers'

export default {
  name: 'GroupOrderTierSelection',
  props: {
    tier: {
      type: Object,
      required: true
    },
    sequence: {
      type: Number,
      required: true
    },
    selectedVariants: {
      type: Array,
      required: true
    },
    activeItems: {
      type: Array,
      default: function() {
        return []
      }
    },
    payload: {
      type: Array,
      default: () => []
    }
  },

  components: {
    ProductPortrait,
    BundlePortrait
  },
  computed: {
    // Handles filtering out card from tier selection
    computedList() {
      return this.tier.tierDetails.filter(item =>
        item.itemableType == 'Product'
          ? !isCard(item.itemableAttributes.tag_list)
          : {} || item.itemableType == 'Bundle'
      )
    },
    tierHeader() {
      if (this.tier.giftsLimit > 1) {
        if (this.tier.selectionType && this.tier.selectionType === 'EXACTLY') {
          return `Tier ${this.sequence} - (Choose exactly ${this.tier.giftsLimit} items)`
        } else if (
          this.tier.selectionType &&
          this.tier.selectionType === 'UPTO'
        ) {
          return `Tier ${this.sequence} - (Choose up to ${this.tier.giftsLimit} items)`
        } else {
          return `Tier ${this.sequence} - (Choose ${this.tier.giftsLimit} items)`
        }
      } else {
        if (this.tier.selectionType && this.tier.selectionType === 'EXACTLY') {
          return `${
            this.tier.name ? this.tier.name : 'Tier ' + this.sequence
          } - (Choose exactly ${this.tier.giftsLimit} item)`
        } else if (
          this.tier.selectionType &&
          this.tier.selectionType === 'UPTO'
        ) {
          return `${
            this.tier.name ? this.tier.name : 'Tier ' + this.sequence
          } - (Choose up to ${this.tier.giftsLimit} item)`
        } else {
          return `${
            this.tier.name ? this.tier.name : 'Tier ' + this.sequence
          } - (Choose ${this.tier.giftsLimit} item)`
        }
      }
    },
    giftsLimit() {
      const products = this.payload.filter(
        item => parseInt(item.tierId) === parseInt(this.tier.id)
      )
      if (this.tier.selectionType && this.tier.selectionType === 'UPTO') {
        // users can select up to any limit so the product card
        //  should not be disabled after limit is reached
        return false
      } else {
        return products.length === this.tier.giftsLimit
      }
    }
  },

  methods: {
    getBundleSelected(bundleId) {
      return this.selectedVariants.filter(
        variant => parseInt(variant.bundleId) === parseInt(bundleId)
      )
    },

    handleSelection(product) {
      const itemExists = this.payload.find(
        item => parseInt(item.itemId) === parseInt(product.itemId)
      )

      if (itemExists) {
        this.$emit('removeSelection', itemExists)
      } else {
        if (this.giftsLimit) {
          this.$emit('handleSingleProduct', product)
        } else {
          this.$emit('handleSelection', product)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.mt-3 {
  margin-top: 3rem;
}

h5 {
  font-size: 1rem;
  padding-bottom: 1rem;
  font-family: $inter;
}

.tier-gallery {
  display: flex;
  gap: 5.5rem 2rem;
  flex-wrap: wrap;
  padding: 3rem 0rem;
  border-top: 8px solid $onyx;
  margin: 0 auto;
  justify-content: center;
}

.gallery-image {
  margin-bottom: 1rem;
  /* width: 25%; */
}

.group-order-footer {
  margin-bottom: 2rem;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 1rem;
  background-color: $light-grey;
  height: 8rem;
}

.left-item {
  grid-column-start: 1;
  grid-column-end: 5;
  justify-self: end;
  align-self: center;
}

.center-item {
  grid-column-start: 5;
  grid-column-end: 7;
  align-self: center;
}

.right-item {
  grid-column-start: 7;
  grid-column-end: 10;
  justify-self: start;
  align-self: center;
}

@media screen and (max-width: 950px) and (min-width: 770px) {
  .gallery {
    padding-top: 2rem;
    margin-bottom: 2rem;
  }

  .gallery-image {
    flex-basis: 48%;
    width: 48%;
  }
}

@media screen and (max-width: 769px) and (min-width: 350px) {
  .gallery {
    flex-direction: column;
  }

  .gallery-image {
    flex-basis: 80%;
    margin-bottom: 3.5rem;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .gallery-image {
    flex-basis: unset;
    margin-bottom: 3.5rem;
  }
}
</style>
